// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

 .Polaris-Popover__Content{
  max-width: 45rem !important;
}

.Polaris-Page {
  padding-bottom: 24px;
}

.faq-item {
  border: 1px solid #e1e3e5;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
}

.faq-item + .faq-item {
  margin-top: 12px;
}

.faq-item-button {
  width: 100%;
  text-align: left;
  padding: 14px 16px;
  background: transparent;
  border: none;
  cursor: pointer;
}

.faq-item-button:focus-visible {
  outline: 2px solid #111;
  outline-offset: 2px;
  border-radius: 10px;
}

.faq-item-icon {
  width: 24px;
  height: 24px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  font-weight: 600;
  color: #111;
  line-height: 1;
}

.faq-item-content {
  padding: 12px 16px 16px;
  border-top: 1px solid #e1e3e5;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE;aACW;AACb;;CAEC;EACC,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;AAC/B","sourcesContent":["body {\r\n  margin: 0;\r\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\r\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\r\n    sans-serif;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\ncode {\r\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\r\n    monospace;\r\n}\r\n\r\n .Polaris-Popover__Content{\r\n  max-width: 45rem !important;\r\n}\r\n\r\n.Polaris-Page {\r\n  padding-bottom: 24px;\r\n}\r\n\r\n.faq-item {\r\n  border: 1px solid #e1e3e5;\r\n  border-radius: 12px;\r\n  background: #fff;\r\n  overflow: hidden;\r\n}\r\n\r\n.faq-item + .faq-item {\r\n  margin-top: 12px;\r\n}\r\n\r\n.faq-item-button {\r\n  width: 100%;\r\n  text-align: left;\r\n  padding: 14px 16px;\r\n  background: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.faq-item-button:focus-visible {\r\n  outline: 2px solid #111;\r\n  outline-offset: 2px;\r\n  border-radius: 10px;\r\n}\r\n\r\n.faq-item-icon {\r\n  width: 24px;\r\n  height: 24px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #111;\r\n  line-height: 1;\r\n}\r\n\r\n.faq-item-content {\r\n  padding: 12px 16px 16px;\r\n  border-top: 1px solid #e1e3e5;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
